export const REDUX_STORE_HOME = 'add_suggested_source'
export const SOURCE_NAME = 'SuggestedSource'
export const SUGGEST_SOURCES_PAGE = 'suggest-sources'
export const SUGGEST_ARTICLES_PAGE = 'suggest-articles'
export const SUGGEST_CONTENT_PAGE = 'suggest-content'

export interface Prompt {
  role: string,
  content: string,
  placeholder?: string,
}
export const EXPLORE_MORE_PROMPT: Prompt = {
  role: "user",
  content: "Not satisfied with the given summary & topics. Want to explore more."
}
export const DEFAULT_PROMPTS: Prompt[] = [
  {
    role: "user",
    content: 'I need help deciding on a topic for my next newsletter. Any suggestions?',
  },
  {
    role: "user",
    content: "Can you suggest some trending topics for our upcoming newsletter?",
  },
  {
    role: "user",
    content: "I'm running out of ideas for my newsletter. Any creative suggestions?"
  },
  {
    role: "system",
    content: "Enter a URL with content you like.",
    placeholder: "Please provide URL."
  }
]
